import { InvestorCapitalAccountDTO } from './InvestorCapitalAccountDTO';
import { CustomAllocationDTO } from './CustomAllocationDTO';
import { CustomAllocationValue } from '../../capital-account/CustomAllocationValue';


export class CustomAllocationValueDTO {
  uuid: string;
  investor: InvestorCapitalAccountDTO;
  customAllocation: CustomAllocationDTO;
  manualValue: number;

  constructor(
    uuid: string,
    investor: InvestorCapitalAccountDTO,
    customAllocation: CustomAllocationDTO,
    manualValue: number,
  ) {
    this.uuid = uuid;
    this.investor = investor;
    this.customAllocation = customAllocation;
    this.manualValue = manualValue;
  }

  static toEntity(dto: CustomAllocationValueDTO): CustomAllocationValue {
    return new CustomAllocationValue(
      dto.uuid,
      InvestorCapitalAccountDTO.toInvestorCapitalAccount(dto.investor),
      CustomAllocationDTO.toEntity(dto.customAllocation),
      dto.manualValue,
    );
  }

  static toEntityList(dtoList: CustomAllocationValueDTO[]): CustomAllocationValue[] {
    return dtoList.map((dto) => CustomAllocationValueDTO.toEntity(dto));
  }
}
